const BUSINESS_TYPES = [
  {
    label: "农业商户/农场商店",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "动物收容所/慈善机构",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "后备育肥场",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "肉牛生产者",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "肉鸡", value: "Broilers", id: "broilers" },
  {
    label: "采购组织",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "犊牛生产",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "犊牛牧场/开发商",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "牛只采购商", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "合同饲养者",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "合作社", value: "Cooperative", id: "cooperative" },
  {
    label: "企业办公室",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "母牛/犊牛经营",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "奶牛生产",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "经销商/代理商",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "饲料厂", value: "Feed Mill", id: "feed_mill" },
  { label: "育肥场", value: "Feedyard", id: "feedyard" },
  {
    label: "饲养者/饲养场",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "孵化场", value: "Hatchery", id: "hatchery" },
  {
    label: "小母牛生产",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "蛋鸡一体化",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "蛋鸡", value: "Layers", id: "layers" },
  { label: "媒体", value: "Media", id: "media" },
  {
    label: "牛奶合作社/采购商",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "混合/其他生产者",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "营养品供应商",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "包装商/加工商",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "宠物零售店",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "药房", value: "Pharmacy", id: "pharmacy" },
  {
    label: "家禽育种者",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "家禽一体化企业",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "绵羊生产者", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "架子牛经营",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "牲畜围场/销售场",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "生猪生产者", value: "Swine Producer", id: "swine_producer" },
  { label: "火鸡", value: "Turkeys", id: "turkeys" },
  {
    label: "大学/教育机构",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "兽医诊所",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "批发商/零售商",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "羊毛采购商", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "必填",
    },
  },
  salutation: {
    label: "称呼",
    placeholder: "选择称呼",
    errors: {
      required: "称呼为必填项",
      invalid: "请选择有效的称呼",
    },
  },
  firstName: {
    label: "名字",
    placeholder: "张三",
    errors: {
      required: "名字为必填项",
      minLength: "名字至少需要2个字符",
      maxLength: "名字最多50个字符",
    },
  },
  lastName: {
    label: "姓氏",
    placeholder: "李",
    errors: {
      required: "姓氏为必填项",
      minLength: "姓氏至少需要2个字符",
      maxLength: "姓氏最多50个字符",
    },
  },
  email: {
    label: "电子邮箱",
    placeholder: "zhang.san@example.org",
    description: "请输入您的个人电子邮件地址，而不是共享邮箱。",
    prefixWarningTitle: "检测到共享邮箱",
    prefixWarningDescription:
      "我们建议使用个人电子邮件地址以获得更好的个性化体验",
    errors: {
      required: "电子邮箱为必填项",
      invalidEmail: "请输入有效的电子邮件地址",
      emailAssociatedWithYourAccount:
        "您的电子邮件地址已关联到您的账户，无法更改。",
    },
  },
  confirmEmail: {
    label: "确认电子邮箱",
    placeholder: "zhang.san@example.org",
    errors: {
      required: "确认电子邮箱为必填项",
      invalidEmail: "请输入有效的电子邮件地址",
      emailMatchError: "电子邮件地址不匹配",
    },
  },
  password: {
    label: "密码",
    placeholder: "输入您的密码",
    errors: {
      required: "密码为必填项",
    },
  },
  confirmPassword: {
    label: "确认密码",
    placeholder: "确认您的密码",
    errors: {
      required: "确认密码为必填项",
      passwordMatchError: "密码不匹配",
    },
  },
  addressLine1: {
    label: "地址第1行",
    placeholder: "中山路123号",
    errors: {
      required: "地址第1行为必填项",
      minLength: "地址第1行至少需要5个字符",
      maxLength: "地址第1行最多100个字符",
    },
  },
  addressLine2: {
    label: "地址第2行",
    placeholder: "4B室",
    errors: {
      required: "地址第2行为必填项",
      maxLength: "地址第2行最多100个字符",
    },
  },
  city: {
    label: "城市/城镇",
    placeholder: "北京",
    errors: {
      required: "城市/城镇为必填项",
      minLength: "城市/城镇至少需要2个字符",
      maxLength: "城市/城镇最多50个字符",
    },
  },
  state: {
    label: "省份/州",
    placeholder: "选择省份/州",
    errors: {
      required: "省份/州为必填项",
      invalid: "请选择有效的省份/州",
    },
  },
  jurisdiction: {
    label: "执照管辖区",
    placeholder: "选择执照管辖区",
    errors: {
      required: "执照管辖区为必填项",
      invalid: "请选择有效的管辖区",
    },
  },
  zipCode: {
    label: "邮政编码",
    placeholder: "100000",
    errors: {
      required: "邮政编码为必填项",
      invalid: "请输入有效的邮政编码",
    },
  },
  role: {
    label: "职位",
    placeholder: "选择您的职位",
    errors: {
      required: "请选择您的职位",
      invalid: "请选择有效的职位",
    },
  },
  businessType: {
    label: "企业类型",
    placeholder: "选择企业类型",
    errors: {
      required: "企业类型为必填项",
      invalid: "请选择有效的企业类型",
    },
  },
  businessName: {
    label: "企业名称",
    placeholder: "输入企业名称",
    errors: {
      required: "企业名称为必填项",
      minLength: "企业名称至少需要2个字符",
      maxLength: "企业名称最多100个字符",
    },
  },
  businessSearch: {
    label: "企业搜索：",
    addNewAccount: "添加新企业账户",
    canNotFindBusiness: "找不到您的企业？",
    guideline: "请输入您的邮政编码，然后从下面的列表中选择。",
    guidelineForNameSearch: "请输入完整的企业名称，然后从列表中选择。",
    placeholder: "您在哪里工作？",
    noResults: "未找到结果",
    searching: "搜索中...",
    selectedBusinessHeading: "已选择的企业：",
    selectedBusinessNotCorrect: "不正确？",
    selectedBusinessTryAgain: "重试",
    selectedBusinessDismiss: "取消企业",
    resultsFound: {
      singular: "找到1个企业",
      plural: "找到多个企业",
    },
    errors: {
      network: "我们在连接企业搜索查找器时遇到问题。请稍后重试。",
    },
  },
  explicitConsent: {
    label:
      "勾选此框即表示我同意Elanco的使用条款，并确认Elanco将根据Elanco的隐私声明收集和处理我的个人信息",
    errors: {
      required: "电子邮件同意为必填项",
    },
  },
  telephone: {
    label: "个人电话",
    placeholder: "输入您的个人电话",
    dialCodeLabel: "代码",
    dialCodePlaceholder: "搜索国家...",
    errors: {
      invalid: "请输入有效的电话号码。",
    },
  },
  businessTelephone: {
    label: "企业电话",
    placeholder: "输入您的企业电话",
    dialCodeLabel: "代码",
    dialCodePlaceholder: "搜索国家...",
    errors: {
      invalid: "请输入有效的电话号码。",
    },
  },
  professionalNumber: {
    label: "专业编号",
    placeholder: "1234567",
    errors: {
      required: "请输入专业编号",
      maxLength: "输入超过字符限制",
    },
  },
  addressSearch: {
    errors: {
      required: "此字段为必填项",
    },
  },
  businessSearchField: {
    errors: {
      required: "此字段为必填项",
    },
  },
  checkbox: {
    errors: {
      required: "此字段为必填项",
    },
  },
  checkboxGroup: {
    errors: {
      required: "此字段为必填项",
    },
  },
  combobox: {
    errors: {
      required: "此字段为必填项",
    },
  },
  datePicker: {
    errors: {
      required: "此字段为必填项",
    },
  },
  dateRange: {
    errors: {
      required: "此字段为必填项",
    },
  },
  dateTime: {
    errors: {
      required: "此字段为必填项",
    },
  },
  emailField: {
    errors: {
      required: "此字段为必填项",
    },
  },
  fileInput: {
    errors: {
      required: "请选择文件",
    },
  },
  number: {
    errors: {
      required: "请输入数字",
      minValue: "请输入高于最小值的值",
      maxValue: "请输入低于最大值的值",
    },
  },
  passwordField: {
    errors: {
      required: "此字段为必填项",
    },
  },
  rangeSlider: {
    errors: {
      required: "此字段为必填项",
    },
  },
  select: {
    errors: {
      required: "此字段为必填项",
    },
  },
  telephoneField: {
    errors: {
      required: "请仅输入数字",
      invalidTelephone: "请输入有效的电话号码",
      invalidFormat: "无效的号码格式",
    },
  },
  text: {
    errors: {
      required: "请仅使用字母（A-Z）、数字（0-9），不要使用符号",
      maxLength: "输入超过字符限制",
      minLength: "输入至少需要2个字符",
    },
  },
  textarea: {
    characters: "字符",
  },
  time: {
    errors: {
      required: "此字段为必填项",
    },
  },
  form: {
    errors: {
      generic: "提交表单时遇到错误。请重试。",
      reportAnIssue: "请报告问题。",
      configuration: "配置错误",
      noFormQuestionsAvailable: "没有可用的表单问题。",
      formComponentLoad: "由于不支持的字段，无法加载表单组件。",
      code: "代码",
      type: "类型",
      missingRequiredFields:
        "此表单缺少必填字段（电子邮件和/或同意）。请联系管理员修复表单配置。",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "学术人员", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "动物福利 - 其他",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "动物福利 - 零售员工",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "动物福利 - 兽医",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "动物福利 - 兽医护士",
    id: "animal_welfare_vet nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "动物福利 - 志愿者",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "肉牛/育肥场推广",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "肉牛生产者",
    id: "beef_producer",
  },
  { value: "Breeder", label: "育种者", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "企业管理员/前台接待",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "企业所有者/合伙人",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "咨询营养师",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "企业兽医雇员（非医院）",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "奶牛生产者",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "经销商", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "经销商代表，外勤",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "经销商代表，内勤",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "教育机构 - 高中学生",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "教育机构 - 职业学院学生",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "教育机构 - 大学生",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "美容师", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "诊所主任",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "营养/饲料销售",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "营养专业人士",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "营养师", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "办公室/诊所经理",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "非处方药零售商", id: "otc_retailer" },
  { value: "Pharmacist", label: "药剂师", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "药房 - 员工",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "生猪生产者", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "家禽生产者",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "诊所所有者，非兽医博士",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "前台接待/客户服务",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "经销商店 - 员工",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "学生RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "兽医",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "培训师", id: "trainer" },
  { value: "Veterinarian", label: "兽医", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "兽医，诊所所有者",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "兽医助理",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "兽医护士",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "兽医诊所 - 其他",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "兽医诊所 - 兽医",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "兽医诊所 - 兽医护士",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "兽医专家",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "兽医学生",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "兽医外科医生",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "兽医技术员",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "批发商", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "博士",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "先生",
    value: "M.",
    id: "m",
  },
  {
    label: "小姐",
    value: "Miss",
    id: "miss",
  },
  {
    label: "先生",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "夫人",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "女士",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "先生/女士",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "教授",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
